module.exports = global["setCookie"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/exports-loader/index.js?setCookie!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./functions.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?setCookie!../node_modules/exports-loader?setCookie!../legacy/src/legacy/js/functions.js
// module id = 277
// module chunks = 0